export default __webpack_public_path__ + "static/media/Metropolis-Black.1510951e.otf";